import React from 'react';
import Keycloak from 'keycloak-js';
import PropTypes from 'prop-types';
import {useDispatch} from 'react-redux';
import {ReactKeycloakProvider} from '@react-keycloak/web';


import config from '../../../../config';

import * as authActions from '../authActions';
import * as authConstants from '../authConstants';

import authService from '../../../../services/AuthService';

import LoadingIndicator from '../../../global/LoadingIndicator';


const keycloak = new Keycloak({
    ...config.auth,
    enableLogging: true,
    url: config.endpoints.auth.host + config.endpoints.auth.path
});

function AuthProvider({children}) {

    const dispatch = useDispatch();

    return (
        <ReactKeycloakProvider
            authClient={keycloak}
            initOptions={
                {
                    onLoad: 'check-sso',
                    silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html'
                }
            }
            LoadingComponent={<LoadingIndicator isViewport={true}/>}
            onEvent={(authEvent, error) => {

                // authEvent equals redux-event
                switch (authEvent) {

                    case authConstants.EVENT_AUTH_SUCCESS:
                    case authConstants.EVENT_AUTH_REFRESH_SUCCESS:

                        authService.setToken(keycloak.token);
                        break;

                    case authConstants.EVENT_AUTH_LOGOUT:
                    case authConstants.EVENT_AUTH_REFRESH_ERROR:

                        // logout initiated from keycloak
                        authService.setToken(null);

                        // full load to fully reset application state
                        window.location = config.host.uri;

                        break;

                    default:

                        return null;
                }

                const dispatchAction = authActions[authEvent];
                if (dispatchAction) {
                    dispatch(dispatchAction(keycloak, error));
                }
            }}
        >
            {children}
        </ReactKeycloakProvider>
    );
}


AuthProvider.propTypes = {
    children: PropTypes.any
};


export default AuthProvider;
